"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sprintf;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
/**
 * Simple function for formatting strings.
 * Replaces placeholders with values passed as extra arguments
 */


function sprintf(format) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var index = 0;
  return format.replace(/%s/g, function () {
    return String(args[index++]);
  }).replace(/%j/g, function () {
    return String(JSON.stringify(args[index++], getCircularReplacer()));
  });
}

function getCircularReplacer() {
  var seen = new WeakSet();
  return function (key, value) {
    if ((0, _typeof2.default)(value) === 'object' && value !== null) {
      if (seen.has(value)) {
        return '[Circular]';
      }

      seen.add(value);
    }

    return value;
  };
}